import { AxiosError } from 'axios';

const TIMEOUT_CODE = 'ECONNABORTED';

export enum HttpStatus {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  REQUEST_TIMEOUT = 408,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
  GATEWAY_TIMEOUT = 504,
}

export interface RequestErrorMessages {
  [HttpStatus.UNAUTHORIZED]?: string;
  [HttpStatus.FORBIDDEN]?: string;
  [HttpStatus.NOT_FOUND]?: string;
  [HttpStatus.REQUEST_TIMEOUT]?: string;
  [HttpStatus.TOO_MANY_REQUESTS]?: string;
  [HttpStatus.INTERNAL_SERVER_ERROR]?: string;
  [HttpStatus.BAD_GATEWAY]?: string;
  [HttpStatus.SERVICE_UNAVAILABLE]?: string;
  [HttpStatus.GATEWAY_TIMEOUT]?: string;
}

const defaultMessages: RequestErrorMessages = {
  [HttpStatus.UNAUTHORIZED]:
    'You are not authenticated. Please, logout and login again.',
  [HttpStatus.FORBIDDEN]:
    'Your password and email do not match. Please try again.',
  [HttpStatus.NOT_FOUND]:
    'Request was not found or there is a problem with your connection.',
  [HttpStatus.REQUEST_TIMEOUT]: 'Service temporarily unavailable.',
  [HttpStatus.TOO_MANY_REQUESTS]:
    'You have made too many requests and are temporarily blocked.',
  [HttpStatus.INTERNAL_SERVER_ERROR]: 'Service temporarily unavailable.',
  [HttpStatus.BAD_GATEWAY]: 'Service temporarily unavailable.',
  [HttpStatus.SERVICE_UNAVAILABLE]: 'Service temporarily unavailable.',
  [HttpStatus.GATEWAY_TIMEOUT]:
    'Server took too long to respond. Please try again or contact Ebury Support.',
};

const ErrorHandler = (
  httpStatus: HttpStatus,
  newRequestErrorMessages: RequestErrorMessages = {}
) => {
  const mergedRequestErrorMessages = {
    ...defaultMessages,
    ...newRequestErrorMessages,
  };
  return httpStatus ? mergedRequestErrorMessages[httpStatus] : null;
};

export const getStatusCode = (error?: unknown) => {
  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as AxiosError;
    return (
      axiosError.response?.status ??
      (axiosError.code === TIMEOUT_CODE ? 504 : 404)
    );
  }
  return 404;
};

export default ErrorHandler;
